import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "name", "className", "onChange", "defaultChecked"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function NewCheckbox(_ref) {
  var label = _ref.label,
      name = _ref.name,
      className = _ref.className,
      onChange = _ref.onChange,
      defaultChecked = _ref.defaultChecked,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useFormContext = useFormContext(),
      getValues = _useFormContext.getValues,
      setValue = _useFormContext.setValue;

  var initialValue = getValues(name);

  var _useState = useState(initialValue || defaultChecked),
      isChecked = _useState[0],
      setIsChecked = _useState[1];

  var handleChange = function handleChange(e) {
    var target = e.target;
    setIsChecked(target.checked);
    setValue(name, target.checked);
  };

  useEffect(function () {
    setIsChecked(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/_jsx("label", {
    htmlFor: name,
    className: "my-3 flex cursor-pointer select-none",
    children: /*#__PURE__*/_jsxs("div", {
      className: "checkbox relative flex items-center ".concat(className),
      role: "checkbox",
      "aria-disabled": props.disabled,
      "aria-checked": isChecked,
      children: [/*#__PURE__*/_jsx("div", {
        className: "box flex-shrink-0 cursor-pointer border border-black/20",
        children: isChecked && /*#__PURE__*/_jsx("div", {
          className: "check-mark bg-brand-secondary h-full w-full"
        })
      }), /*#__PURE__*/_jsx("input", _objectSpread({
        id: name,
        type: "checkbox",
        name: name,
        onChange: handleChange,
        className: "absolute top-0 left-0 right-0 bottom-0 cursor-pointer opacity-0"
      }, props)), /*#__PURE__*/_jsx("p", {
        className: "p-small ml-2 ",
        children: label
      })]
    })
  });
}